import { enums, literal, nullable, object } from 'superstruct';
import { ListResourceDto } from '@arc/shared/util-data';
import { arcApiSchema } from '@arc/shared/util-route-schema';
import { parsableInteger } from '@arc/shared/util-superstruct';
import { AddFilterDto } from './dtos/add-filter.dto';
import { EditFilterDto } from './dtos/edit-filter.dto';
import { ViewFilterDto } from './dtos/view-filter.dto';
import { FILTER_TYPES } from './filter-types';
const p = arcApiSchema.prefix('filters');
export const ListFilters = p.get('', {
  req: object({
    query: object({
      filterType: enums(FILTER_TYPES)
    })
  }),
  res: ListResourceDto(ViewFilterDto)
});
export const GetDefaultFilter = p.get('default', {
  req: object({
    query: object({
      filterType: enums(FILTER_TYPES)
    })
  }),
  res: nullable(ViewFilterDto)
});
export const GetFilter = p.get(':id', {
  req: object({
    params: object({
      id: parsableInteger()
    })
  }),
  res: ViewFilterDto
});
export const AddFilter = p.post('', {
  req: object({
    body: AddFilterDto
  }),
  res: ViewFilterDto
});
export const EditFilter = p.patch(':id', {
  req: object({
    params: object({
      id: parsableInteger()
    }),
    body: EditFilterDto
  }),
  res: ViewFilterDto
});
export const DeleteFilter = p.delete(':id', {
  req: object({
    params: object({
      id: parsableInteger()
    })
  }),
  res: literal(undefined)
});